export default {
    textToHMTLFormat(text) { // Заменяет \n на <br>
        return text !== null ? text.replace(/\n/g, '<br>') : ''
    }
}
